export default "__VITE_ASSET__vsTQMDuo__"